import React from "react";

import {View, Text}  from 'react-native'

import cores from '../util/cores'
import dimens from '../util/dimens'

import * as util from '../util/util'

export default props=>{

    return (
        <View style={{alignItems:'center'}}>
            {util.temConteudo(props.mensagem) && <View style={{marginTop:10}}/>}  
			<Text style={{color:cores.fonte_erro, fontSize:dimens.fonte_rotulo}}>{props.mensagem}</Text>
        </View>
    )
} 